import { render, staticRenderFns } from "./SitForm.vue?vue&type=template&id=bc469e9c&"
import script from "./SitForm.vue?vue&type=script&lang=js&"
export * from "./SitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports